/**
 * Extensões de imagens permitidas para processamento da remessa.
 */
const VALID_IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "webp", "gif"];

/**
 * Extrai o nome do arquivo a partir do caminho interno do ZIP.
 */
function getZipEntryFileName(zipEntryPath: string): string {
  return zipEntryPath.split("/").pop() ?? "";
}

/**
 * Verifica se uma entrada do ZIP deve ser ignorada.
 *
 * Regras:
 * - Ignora diretórios
 * - Ignora arquivos internos do macOS
 * - Ignora arquivos ocultos/metadados
 */
function shouldIgnoreZipEntry(zipEntryPath: string, isDirectory: boolean): boolean {
  if (isDirectory) return true;

  if (zipEntryPath.endsWith("/")) return true;

  if (zipEntryPath.includes("__MACOSX")) return true;

  const fileName = getZipEntryFileName(zipEntryPath);

  if (fileName === ".DS_Store") return true;

  if (fileName.startsWith("._")) return true;

  return false;
}

/**
 * Verifica se o arquivo possui uma extensão de imagem válida.
 */
function isValidImageExtension(fileName: string): boolean {
  const fileExtension = (fileName.split(".").pop() ?? "").toLowerCase();
  return VALID_IMAGE_EXTENSIONS.includes(fileExtension);
}

export { getZipEntryFileName, isValidImageExtension, shouldIgnoreZipEntry, VALID_IMAGE_EXTENSIONS };
